<template>
    <LoginLayout>

        <div v-if="isTokenDuringVerification" class="alert bg-info text-white">
            <i class="fa fa-circle-o-notch fa-spin mr-2"></i>
            <span class="font-weight-semibold">Trwa weryfikacja tokenu, proszę czekać...</span>
        </div>

        <div v-else-if="verificationError">
            <div class="alert bg-danger text-white alert-styled-left">
                <span class="font-weight-semibold">Twój link do restartu hasła wygasł.</span>
            </div>

            <p class="font-weight-semibold mb-3">
                Aby rozpocząć procedurę restartu hasła od nowa kliknij poniżej.
            </p>

            <div class="text-center">
                <router-link :to="{name: 'Login', query: {'reset-password': true}}" class="btn btn-primary">
                    Resetuj hasło
                </router-link>
            </div>
        </div>

        <!-- Panel ustawiania nowego hasła  -->
        <div v-else class="mb-0">

            <div class="card-body">
                <form @submit.prevent="setNewPassword" class="login-form">
                    <div class="text-center mb-3">
                        <h5 class="mb-0">Ustawianie nowego hasła</h5>
                        <span class="d-block text-muted">
                            Hasło musi posiadać
                            <span :class="{'text-success': hasAtLeastEightCharacters}">minimum 8 znaków</span>
                            oraz
                            <span :class="{'text-success': hasAtLeastOneBigLetter}">przynajmniej jedną dużą literę</span>
                            i
                            <span :class="{'text-success': hasAtLeastOneNumber}">jedną cyfrę</span>.
                        </span>
                    </div>

                    <div class="form-group form-group-feedback form-group-feedback-left">
                        <input  v-model="password" :class="{'is-valid': isPasswordValid, 'is-invalid': !isPasswordValid && password.length > 0}" type="password" class="form-control" placeholder="Hasło" required>
                        <div class="form-control-feedback">
                            <i class="icon-lock2 text-muted"></i>
                        </div>
                    </div>

                    <div class="form-group form-group-feedback form-group-feedback-left">
                        <input v-model="passwordRepeat" :class="{'is-valid': passwordWasRepeatedCorrect && password.length > 0, 'is-invalid': !passwordWasRepeatedCorrect}" type="password" class="form-control" placeholder="Powtórz hasło" required>
                        <div class="form-control-feedback">
                            <i class="icon-lock2 text-muted"></i>
                        </div>
                    </div>

                    <div v-if="savingPasswordError" class="alert bg-danger text-white">
                        <span class="font-weight-semibold">Ustawianie nowego hasła zakończyło się niepowodzeniem. Spróbuj ponownie!</span>
                    </div>

                    <div v-if="!passwordHasBeenChanged" class="form-group">

                        <button v-if="!isWaiting"
                                type="submit"
                                :disabled="!passwordIsFilledSufficiently"
                                class="btn btn-primary btn-block">
                            Ustaw nowe hasło
                            <i class="icon-circle-right2 ml-2"></i>
                        </button>

                        <button v-else
                                disabled="disabled"
                                type="button"
                                class="btn btn-primary btn-block">
                            Ustawiam nowe hasło... <i class="fa fa-circle-o-notch fa-spin ml-2"></i>
                        </button>
                    </div>


                    <div v-if="passwordHasBeenChanged" class="alert bg-success text-white">
                        <span class="font-weight-semibold">Hasło zostało zmienione. Przejdź do strony logowania.</span>
                    </div>

                    <div class="text-center">
                        <router-link type="button" class="btn btn-link" tag="button" :to="'Login'">
                            Przejdź do strony logowania
                        </router-link>
                    </div>
                </form>
            </div>
        </div>
    </LoginLayout>
</template>

<script>

    import LoginLayout from "./layouts/LoginLayout";
    import {checkResetToken, setNewPassword} from "../services/AuthService";

    export default {
        name: "SetNewPasswordView",
        components: {LoginLayout},
        data() {
            return {

                verificationError: false,
                user: null,

                password: '',
                passwordRepeat: '',

                isWaiting: false,
                savingPasswordError: false,

                passwordHasBeenChanged: false
            }
        },

        mounted() {
            this.verifyToken();
        },

        computed: {

            passwordIsFilledSufficiently() {
                return this.isPasswordValid
                    && this.passwordWasRepeatedCorrect
            },

            isPasswordValid() {
                return this.hasAtLeastEightCharacters
                    && this.hasAtLeastOneBigLetter
                    && this.hasAtLeastOneNumber;
            },

            hasAtLeastEightCharacters() {
                return this.password.length >= 8;
            },

            hasAtLeastOneBigLetter() {
                let match = this.password.match(/[A-Z]+/);

                return !! match;
            },

            hasAtLeastOneNumber() {
                let match = this.password.match(/[0-9]+/);

                return !! match;
            },

            passwordWasRepeatedCorrect() {
                return this.password === this.passwordRepeat;
            },

            isTokenDuringVerification() {
              return (! this.user && ! this.verificationError)
            },

            resetToken() {

                if( ! this.$route.query.hasOwnProperty('key') ) {
                    return null
                }

                return this.$route.query.key;
            }
        },

        methods: {

            verifyToken() {
                checkResetToken(this.resetToken)
                    .then( ({data}) => {
                        this.user = data;
                        this.verificationError = false;
                    })
                    .catch(() => {
                        this.verificationError = true;
                    })
            },

            setNewPassword() {

                if( ! this.passwordIsFilledSufficiently ) {
                    return;
                }
                this.savingPasswordError = false;
                this.isWaiting = true;

                setNewPassword(this.resetToken, this.password)
                    .then( () => {
                        this.isWaiting = false;
                        this.passwordHasBeenChanged = true;
                        this.savingPasswordError = false;
                    })
                    .catch(() => {
                        this.isWaiting = false;
                        this.savingPasswordError = true;
                    })

            }
        }
    }
</script>

<style scoped>
    .form-control.is-valid:focus{
        border-color: #4CAF50!important;
    }

    .form-control.is-invalid:focus{
        border-color: #F44336!important;
    }
</style>
